export default "__VITE_ASSET__CRQGF6Bi__"